import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RatingModule } from 'ngx-bootstrap/rating';
import { SharedModule } from '@nk/shared/shared.module';
import { FeedbackButtonComponent } from '@nk/shared/components/feedback/feedback-button/feedback-button.component';
import { GeneralFeedbackComponent } from '@nk/shared/components/feedback/general-feedback/general-feedback.component';
import { SurveyFeedbackComponent } from '@nk/shared/components/feedback/survey-feedback/survey-feedback.component';

@NgModule({
  declarations: [FeedbackButtonComponent, GeneralFeedbackComponent, SurveyFeedbackComponent],
  exports: [FeedbackButtonComponent],
  imports: [CommonModule, ModalModule.forRoot(), TranslateModule, FormsModule, RatingModule.forRoot(), SharedModule],
})
export class FeedbackModule {}
